import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    AppBar,
    Tabs,
    Tab,
    Badge,
    Button
} from '@material-ui/core';

import {
} from './';

import { PageContext } from '../PageContext';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

export const TabContainer = ({
    children,
    ...props }) => {
    const classes = useStyles();

    const { t, i18n } = useTranslation();

    const {
        state
    } = useContext(PageContext);

    const {
        license,
        configHasChanges,
        errors
    } = state;

    const createTabProps = (tabIndex) => {
        return {
            id: `settings-tab-${tabIndex}`,
            'aria-controls': `settings-tabpanel-${tabIndex}`,
        };
    }

    const [currentIndex, setCurrentIndex] = useState(0);
    const changeIndexHandler = (e, newValue) => {
        setCurrentIndex(newValue);
    };

    return (
        <div className={clsx(classes.root, props.className)}>
            <AppBar position="static" style={{ borderRadius: 5 }}>
                <Tabs value={currentIndex} onChange={changeIndexHandler} aria-label="settings tabs">
                    {children && React.Children.map(children, (child, index) =>

                        <Tab
                            key={`tab-${index}`}
                            label={
                                <Badge
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    color="secondary"
                                    variant="dot"
                                    invisible={errors.find(err => err.errorId === child.props.name) ? false : true}>
                                    {child.props.label}
                                </Badge>
                            }
                            {...createTabProps(child.props.index)} />

                    )}
                </Tabs>
            </AppBar>
            {children && React.Children.map(children, (child) => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { value: currentIndex });
                }
                return child;
            })}
        </div>
    );
}